import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { AdministracionScreen } from "./AdministracionScreen";
import { FlujoEfectivoScreen } from "./FlujoEfectivo/FlujoEfectivoScreen";


export const AdministracionMainScreen = () => {
  return (
    <div className="main-container">
      <Route
        path="/Administracion/Main"
        component={() => <AdministracionScreen />}
      />
      <Route
        path="/Administracion/FlujoEfectivo"
        component={() => <FlujoEfectivoScreen />}
      />
    </div>
  );
};
